const rentLeasePlan_origin_formConfig = [
  {
    el: 'text',
    itemConfig: {
      label: '合同起止日期',
      prop: 'contractDateText',
    },
    // 关联的类别 1-租车 2-以租代购 3-司机合作模式
    showItem: [1, 2, 3],
    itemName: '合同起止日期',
  },
  {
    el: 'text',
    itemConfig: {
      label: '租期',
      prop: 'rentPeriodText',
    },
    showItem: [1, 2, 3],
    itemName: '租期',
  },
  {
    el: 'text',
    itemConfig: {
      label: '赠送天数',
      prop: 'presentDaysText',
    },
    showItem: [1, 2, 3],
    itemName: '赠送天数',
  },
  {
    el: 'text',
    itemConfig: {
      label: '前置免租天数',
      prop: 'preFreeRentDaysText',
    },
    showItem: [1, 2, 3],
    itemName: '前置免租天数',
  },
  {
    el: 'text',
    itemConfig: {
      label: '订单总计金额',
      prop: 'allTotalAmount',
    },
    showItem: [1, 2, 3],
    itemName: '订单总计金额',
  },
  {
    el: 'text',
    itemConfig: {
      label: '押金',
      prop: 'deposit',
    },
    showItem: [1, 3],
    itemName: '押金',
  },
  {
    el: 'text',
    itemConfig: {
      label: '首付款',
      prop: 'firstPayment',
    },
    showItem: [2],
    itemName: '首付款',
  },
  {
    el: 'text',
    itemConfig: {
      label: '租金',
      prop: 'rentAmount',
    },
    showItem: [1, 2],
    itemName: '租金',
  },
  {
    el: 'text',
    itemConfig: {
      label: '全款',
      prop: 'fullPayment',
    },
    showItem: [2],
    itemName: '全款',
  },
  {
    el: 'text',
    itemConfig: {
      label: '其余收款项',
      prop: 'otherAmount',
    },
    showItem: [1, 2, 3],
    itemName: '其余收款项',
  },
]
const rentLeasePlan_formRule = {}
const rentLeasePlan_model = {
  rentCategory: 1,
  contractDateText: '', // 合同起止文本
  rentPeriodText: '', // 租期文本
  presentDaysText: '0天', // 赠送天数显示文本，默认展示0天
  preFreeRentDaysText: '0天', // 前置免租天数显示文本，默认展示0天
  allTotalAmount: '', // 订单总计金额
  deposit: '', // 押金(和首付款互斥)
  rentAmount: '', // 租金(和首付款互斥)
  firstPayment: '', // 首付款(和押金互斥)
  otherAmount: '', // 其余收款项
}
export default function () {
  return {
    rentLeasePlan_origin_formConfig,
    rentLeasePlan_formRule,
    rentLeasePlan_model,
  }
}
